import TagInterface from "@/interfaces/tag.interface";
import axios from "@/libs/axios";
import { reactive, toRefs } from "@vue/composition-api";
import { useQuery } from "@tanstack/vue-query";
import { BvModal } from "bootstrap-vue";
// @ts-ignore
import i18n from "@/libs/i18n";
import { AxiosRequestConfig } from "axios";

interface RootState {
    tags: TagInterface[];
    loading: boolean;
    error: boolean;
}

const state: RootState = reactive({
    tags: [],
    loading: false,
    error: false,
});

export default function useTags(bvModal?: BvModal) {
    const tableColumns = [
        {
            key: "name",
            label: "Name",
            sortable: true,
        },
        {
            key: "color",
            label: "Color",
            sortable: true,
        },
        {
            key: "actions",
            label: "Actions",
        },
    ];

    const fetchTags = (queryParams?: AxiosRequestConfig): void => {
        const { data, isLoading, isError } = useQuery(["tags"], () => axios.get("/tags", queryParams), {
            select: (response: { data: TagInterface[] }) => response.data,
            refetchOnWindowFocus: false,
            staleTime: 5000,
            placeholderData: { data: [] } as any,
        });

        // @ts-ignore
        state.loading = isLoading;
        // @ts-ignore
        state.tags = data;
        // @ts-ignore
        state.error = isError;
    };

    const createOne = (tag: Omit<TagInterface, "id">): Promise<TagInterface> => {
        return axios.post("tags", tag).then((response) => {
            state.tags.push(response.data);
            return response.data;
        });
    };

    const updateOne = (tag: TagInterface): Promise<TagInterface> => {
        return axios.patch(`tags/${tag.id}`, tag).then((response) => {
            state.tags.push(response.data);
            return response.data;
        });
    };

    const deleteOne = (id: number): Promise<unknown> => {
        if (!bvModal) {
            return Promise.resolve(false);
        }
        return bvModal
            .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                title: i18n.t("confirm.Are you sure?"),
                cancelTitle: i18n.t("confirm.Cancel"),
                cancelVariant: "light",
                okTitle: i18n.t("confirm.Yes, delete"),
                hideHeaderClose: false,
                headerCloseVariant: "light",
                centered: true,
            })
            .then((result): unknown => {
                if (result) {
                    return axios.delete(`tags/${id}`).then((response) => {
                        const deleteIndex = state.tags.findIndex((tag) => tag.id === id);
                        state.tags.splice(deleteIndex, 1);

                        return response.data;
                    });
                }
                return false;
            });
    };

    return {
        tableColumns,
        fetchTags,
        createOne,
        updateOne,
        deleteOne,
        ...toRefs(state),
    };
}
